import type { SelectProps } from '@material-ui/core';
import { Box, Select as SelectCore } from '@material-ui/core';
import clsx from 'clsx';
import i18n from 'i18n';
import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import selectStyles from 'styles/select';

type ExtendedSelectProps = SelectProps & {
  inputClass?: string;
};

const Select: FunctionComponent<ExtendedSelectProps> = ({
  label,
  variant,
  children,
  inputClass,
  ...props
}: ExtendedSelectProps) => {
  const classes = selectStyles();
  const { dir } = useSelector((state: $Lns.DefaultState) => state.default);
  const direction = dir ?? i18n.dir();

  return (
    <Box className={direction}>
      {label && <div className={classes.label}>{label}</div>}
      <SelectCore
        classes={{ select: clsx(classes.input, inputClass) }}
        MenuProps={{
          classes: { paper: classes.menu },
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left'
          },
          getContentAnchorEl: null
        }}
        {...(variant !== 'filled' && { disableUnderline: true })}
        {...props}
      >
        {Array.isArray(children) ? children.map(child => child) : children}
      </SelectCore>
    </Box>
  );
};

export default Select;

Select.defaultProps = {
  inputClass: undefined
};
